import React, { useEffect } from 'react';
import { Modal, Form, Select, Input } from 'antd';

interface RejectPopupProps {
  visible: boolean;
  onClose: () => void;
  onSubmit: (values: { commentFor: string; comment: string }) => void;
  isLoading?: boolean;
  title?: string;
}

const RejectPopup: React.FC<RejectPopupProps> = ({ visible, onClose, onSubmit, isLoading = false, title }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (visible) {
      form.resetFields();
    }
  }, [visible, form]);

  return (
    <Modal
      title={title || 'Action'}
      open={visible}
      onOk={() => form.submit()}
      confirmLoading={isLoading}
      onCancel={() => {
        form.resetFields();
        onClose();
      }}
      destroyOnClose
    >
      <Form form={form} layout="vertical" onFinish={onSubmit}>
        <Form.Item
          name="commentFor"
          label="Comment For"
          rules={[{ required: true, message: 'Please select an option' }]}
        >
          <Select placeholder="Select">
            <Select.Option value="CUSTOMER">Customer</Select.Option>
            <Select.Option value="USER">System Admin</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item name="comment" label="Comment" rules={[{ required: true, message: 'Please enter a comment' }]}>
          <Input.TextArea placeholder="Enter your comment" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default RejectPopup;
